import { useEffect, useState } from "react";
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Button, Paper, Typography, Icon, useTheme, LinearProgress, CircularProgress, Grid, TextField } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Box } from "@mui/system";

import { IListagemTipo, RenderTree, TipoService } from "../../shared/services/api/tipo/TipoService";
import { AutoCompleteDeSetor } from "../../shared/components/autocompletes/AutoCompleteDeSetor";
import { AlertSnackBar } from "../../shared/components/alert/AlertSnackBar";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from "../../shared/environment";
import { DocumentoService } from "../../shared/services/api/documento/DocumentoService";


export const Certificar: React.FC = () => {

    const theme = useTheme();

    const [rows, setRows] = useState<IListagemTipo[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [selectedIdTipo, setSelectedIdTipo] = useState(0);
    const [selectedNomeTipo, setSelectedNomeTipo] = useState('nenhum');
    // const [selectedNivel, setSelectedNivel] = useState(0);
    const [selected, setSelected] = useState<string[]>([]);

    const [qtdeCertificar, setQtdeCertificar] = useState<number>(0);

    const [idSetor, setIdSetor] = useState<number | undefined>(undefined);
    useEffect(() => { setIdSetor(Number(localStorage.getItem("idSetor"))) }, [])

    const [senha, setSenha] = useState("");

    const handleSelect = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setSelected(nodeIds);
    };

    const handleClick = (idTipo: number, nomeTipo: string, nivel: number) => {
        setSelectedIdTipo(idTipo);
        setSelectedNomeTipo(nomeTipo);
        // setSelectedNivel(nivel);
    }

    const handleLimparSelecao = () => {
        setSelectedIdTipo(0);
        setSelectedNomeTipo('nenhum');
        // setSelectedNivel(0);
        setSelected((oldSelected) =>
            oldSelected.length === 0 ? ['1', '2', '3', '4', '5', '6', '7', '8', '9'] : [],
        );
    }

    const handleCheck = () => {
        setIsLoading(true);

        DocumentoService.paraCertificar(selectedIdTipo).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) {//verificar se deu erro
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            } else {
                setQtdeCertificar(result);
            }
        });

        setAbrir(true);
    }

    useEffect(() => {

        listagemTipos();

    }, [idSetor]);

    const listagemTipos = () => {
        if (idSetor !== undefined && idSetor !== null && idSetor !== 0) {
            setRows([]);
            setIsLoading(true);
            TipoService.getByIdSetor(idSetor, false, true).then((result) => {
                setIsLoading(false);

                if (result instanceof Error) {//verificar se deu erro
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                }
                else {
                    setRows(result);

                }
            });
        } else {
            setRows([]);
        }
    }

    const renderTree = (nodes: RenderTree) => (
        <TreeItem key={nodes.idTipo} nodeId={(nodes.idTipo).toString()} label={nodes.nomeTipo} onClick={() => handleClick(nodes.idTipo, nodes.nomeTipo, nodes.nivel)}>
            {Array.isArray(nodes.tipos)
                ? nodes.tipos.map((node) => renderTree(node))
                : null}
        </TreeItem>
    );

    const [abrir, setAbrir] = useState(false);
    const handleCancel = () => {
        setAbrir(false);
        setQtdeCertificar(0);
    }

    const [selectedFile, setSelectedFile] = useState<File>();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [pdfFile, setPdfFile] = useState("");
    const [file, setFile] = useState<FormData>();

    const handleArquivo = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files?.length === 1) {
            if (!!event.target.files[0]) {
                setPdfFile(URL.createObjectURL(event.target.files[0]));
                setSelectedFile(event.target.files[0]);
                setIsFilePicked(true);
                setFile(undefined);
            }
        }
        else if (event.target.files !== null && event.target.files?.length > 1) {
            const files = event.target.files;

            const arquivo = new FormData();
            for (let i = 0; i < files.length; i++) {
                arquivo.append('arquivos', files[i]);
            }
            setPdfFile("")
            setFile(arquivo);
            setSelectedFile(new File([], ""));
            setIsFilePicked(false);
        }
    };

    useEffect(() => { console.log(selectedFile) }, [selectedFile]);

    const handleCertificar = () => {
        setAbrir(false);
        setIsLoading(true);
        if (selectedFile === undefined) return setAlert({ tipoAlert: "erro", mensagem: "Selecione um certificado" });
        DocumentoService.certificarEmLote(selectedIdTipo, senha, selectedFile).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) {//verificar se deu erro
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            } else {
                setAlert({ tipoAlert: "sucesso", mensagem: "Certificação agendada com sucesso" });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        });
    }

    return (
        <LayoutBaseDePagina
            titulo="Certificação em lotes"
            barraDeFerramentas={null}
        >
            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <Box
                component={Paper}
                height={theme.spacing(5)}
                marginX={1}
                padding={1}
                paddingX={2}
                display="flex"
                justifyContent="center"
                gap={1}
                marginBottom={theme.spacing(1)}
            >
                <AutoCompleteDeSetor selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} />
            </Box>

            <Box
                component={Paper}
                height={theme.spacing(5)}
                marginX={1}
                padding={1}
                paddingX={2}
                display="flex"
                gap={1}
                justifyContent="center"
            >
                {selected.length !== 0 && (
                    <Typography variant="button" noWrap>
                        <Button
                            color="warning"
                            disableElevation
                            variant="contained"
                            endIcon={<Icon>clear</Icon>}
                            onClick={handleLimparSelecao}
                        >
                            Desselecionar
                        </Button>
                    </Typography>
                )}

                {selected.length !== 0 && (
                    <Typography variant="button" noWrap>
                        <Button
                            color="success"
                            disableElevation
                            variant="contained"
                            endIcon={<Icon>check</Icon>}
                            onClick={handleCheck}
                        >
                            Certificar
                        </Button>
                    </Typography>
                )}

            </Box>

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" padding={2}>
                {isLoading && (
                    <LinearProgress variant="indeterminate" />
                )}
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    selected={selected}
                    onNodeSelect={handleSelect}
                    sx={{ width: 500, minHeight: 500, flexGrow: 1 }}
                >
                    {rows.map(tipo => renderTree(tipo))}

                </TreeView>

                <Dialog
                    open={abrir}
                    onClose={handleCancel}
                    fullWidth
                    maxWidth={'md'}
                >
                    <DialogTitle> Certificar {!isLoading ? qtdeCertificar.toString() : <CircularProgress variant='indeterminate' color='inherit' size={20} />} documentos do tipo {selectedNomeTipo} </DialogTitle>
                    <DialogContent dividers>
                        <>
                            <Grid>
                                <Box display="flex" gap={1} alignItems="center">
                                    <Button
                                        variant="contained"
                                        component="label"
                                        disabled={isLoading || !selectedIdTipo}
                                    >
                                        Selecionar arquivo
                                        <input
                                            type="file"
                                            accept='.pfx'
                                            hidden
                                            onChange={handleArquivo}
                                        />
                                    </Button>

                                    {isFilePicked && selectedFile &&
                                        <Typography> {selectedFile.name} </Typography>
                                    }

                                    {!isFilePicked && file === undefined &&
                                        <Typography> Nenhum arquivo selecionado </Typography>
                                    }

                                    {file &&
                                        <Typography> {Array.from(file.values()).filter(value => value !== "").length} arquivos selecionados </Typography>
                                    }
                                </Box>

                                <TextField
                                    label="Senha"
                                    type="password"
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    autoComplete="off"
                                    aria-autocomplete="none"
                                    onChange={(event) => { setSenha(event.target.value); }}
                                    disabled={isLoading || !selectedIdTipo}
                                />
                            </Grid>


                        </>
                    </DialogContent>
                    <DialogActions>
                        <Box
                            width="100%"
                            marginX={1}
                            padding={1}
                            paddingX={2}
                            gap={1}
                            display="flex"
                            justifyContent="center"
                        >
                            <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleCancel}>
                                <Typography variant='button' noWrap> Fechar </Typography>
                            </Button>
                            <Button
                                variant="contained"
                                disabled={isLoading || qtdeCertificar <= 0 || senha === "" || !isFilePicked && file === undefined}
                                startIcon={false ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : <Icon>save</Icon>}
                                onClick={handleCertificar}>
                                <Typography variant='button' noWrap> Certificar </Typography>
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>

            </Box>
        </LayoutBaseDePagina>
    )
}